import { redirect } from 'react-router-dom';
import { VerifyToken } from '../apis/login';

const useAuth =  async () => {
    const result = await VerifyToken()
    if (result.status === 200) {
        return true
    } else {
        return redirect('/login')
    }
};

export default useAuth

